import {Observable} from 'rxjs/Observable';
import {createPrizeCompleted, errorCreatingPrizeAction, Types} from './actions';
import {createResourcePageSelector} from 'resources/selectors';
import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';

const getResourcePage = createResourcePageSelector(ResourceApi.Types.Prize);

const submitCreatePrizeEpic = (action$, store) => action$.ofType(Types.SUBMIT_CREATE_PRIZE)
  .mergeMap(({title, lang, prizeType}) => {
    const resourcePage = getResourcePage(store.getState().resources);
    const prizeCreation$ = ResourceApi.create(ResourceApi.Types.Prize, {
      title,
      lang,
      type: prizeType
    }, []);

    return prizeCreation$
      .mergeMap(({response}) => Observable.of(
        createPrizeCompleted(response.object.resourceId.id),
        ResourceActions.createdResourceAction(response.object, null, [], [], []),

        // refresh prize list
        ResourceActions.getResourcePageAction(ResourceApi.Types.Prize, 20, resourcePage.page)
      ))
      .catch(error => Observable.of(
        error.xhr
          ? errorCreatingPrizeAction(error.response)
          : {type: 'ERROR', error}
      ));
  });

export default [
  submitCreatePrizeEpic
];



// WEBPACK FOOTER //
// ./public/pages/PrizeCreator/epics.js